import { useCurrentUser } from '@cosuno/authentication-frontend';
import { COLOR, Icon, Label } from '@cosuno/cosuno-ui';
import React from 'react';

import { COMPANY_TYPE } from '~/__gql__/graphql';
import useTranslation from '~/shared/hooks/useTranslation';

import { PromptBar, TextWrapper } from './Styles';

export const AgentUserLimitedAccessPrompt: React.FC = () => {
  const { t } = useTranslation('company');
  const user = useCurrentUser();

  if (!user || user.company.type !== COMPANY_TYPE.agent || !user.isAwaitingApproval) {
    return null;
  }

  return (
    <PromptBar data-cy-user-limited-access-prompt $color={COLOR.highlightNeon}>
      <TextWrapper>
        <Icon type="info" color={COLOR.white} size={20} />
        <Label variant="large" color={COLOR.white}>
          {t('userLimitedAccessPrompt', { subcontractorName: user.company.name })}
        </Label>
      </TextWrapper>
    </PromptBar>
  );
};
